<script lang="ts">

    import {
        redirectTo,
        historyNavigation,
        storeCurRoute,
    } from "../scripts/router1";
    import {
        idPageHome,
        idPagePodcastCategories,
        idPageAPropos,
        namePagePodcastCategories,
        namePageAPropos,
    } from "../scripts/router2";
    
</script>
  
  
<style lang="scss">

    $color_navigation_bg: $color_secondary;
    $color_navigation: $color_black;
    $color_menu_item: $color_secondary;
    $color_menu_item_hover: $color_tertiary;
    $color_menu_item_active: $color_tertiary;
    $color_bg_menu: $color_primary;

    .logo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 700%;
        height: 50px;
        font-size: 20px;
        text-shadow: 1px 1px 0px $color-tertiary;
        cursor: pointer;
        color: $color_menu_item;
    }

    .menucontenermobile {
        z-index: 100;
        width: 100%;
        background-color: $color_bg_menu;
        display: flex;
        flex-direction: column;
        align-items: center;
        &__one {
            z-index: 100;
            width: 100%;
            height: 50px;
            min-height: 50px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
    }

    .menucontener {
        display: none;
    }

    .navigation {
        z-index: 100;
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        position: initial;
        max-width: 100%;
        transform: none;
        background-color: $color_bg_menu;
        border-radius: 0px;
        color: $color_navigation;
        font-size: 17px;
        width: 100%;
        height: 50px;
        min-height: 50px;
        &__top {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
    }

    .menu {
        width: 100%;
        padding: 0;
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        align-items: center;
        margin: 0px 30px 0px 30px;
        background-color: $color_bg_menu;
        &:hover .subMenu {
            display: block;
            &--clicked {
                display: none;
            }
        }
        &__item {
            position: relative;
            white-space: nowrap;
            color: $color_menu_item;
            cursor: pointer;
            padding: 0px 0px 0px 0px;
            &__selected {
                color: $color_menu_item_active;
            }
            &:hover {
                color: $color_menu_item_hover;
            }
        }
        &__home {
            display: none;
        }
    }

    .footer {
        font-size: small;
        color: $color_black;
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 0 0 0 0;
        &__social {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 40px;
        }
        &__instagram {
            cursor: pointer;
            width: 20px;
            height: 20px;
            background-image: url('../assets/images/instagram_primary.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            margin: 10px;
            &:hover {
                background-image: url('../assets/images/instagram_tertiary.png');
            }
        }
        &__facebook {
            cursor: pointer;
            width: 20px;
            height: 20px;
            background-image: url('../assets/images/facebook_primary.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            margin: 10px;
            &:hover {
                background-image: url('../assets/images/facebook_tertiary.png');
            }
        }
    }

    @include large {
        .logo {
            width: 100%;
            flex-direction: row;
            flex-wrap: wrap;
            font-size: 70px;
            height: auto;
            text-shadow: 1px 1px 2px $color-tertiary;
        }

        .menucontenermobile {
            display: none;
        }

        .menucontener {
            height: 100%;
            width: 100%;
            background-color: $color_bg_menu;
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .navigation {
            font-size: min(2vw, 2em);
            padding: 0 0 0 0;
            justify-content: flex-end;
        }

        .footer {
            &__instagram {
                width: 30px;
                height: 30px;
            }
            &__facebook {
                width: 30px;
                height: 25px;
            }
        }

    }

</style>

<svelte:window on:popstate|preventDefault={historyNavigation} />
<div class="menucontenermobile" >
    <div class="menucontenermobile__one" >
        <div class="logo" on:click={() => redirectTo(idPageHome)} on:keydown={() => redirectTo(idPageHome)}>
            Le Guetteur yoga
        </div>
        <div class="footer">
            <div class="footer__social">
                <a href="https://www.instagram.com/fardeljack/" target="_blank"><div class="footer__instagram"></div></a>
                <a href="https://www.facebook.com/LeGuetteurYoga/" target="_blank"><div class="footer__facebook"></div></a>
            </div>
        </div>
    </div>
    <nav class="navigation">
            <div class="menu">
                <div class="menu__item" class:menu__item__selected={$storeCurRoute == idPageAPropos} on:click={() => redirectTo(idPageAPropos)} on:keydown={() => redirectTo(idPageAPropos)}>
                    {namePageAPropos}
                </div>
            </div>
    </nav>	
</div>
<div class="menucontener" >
    <div class="logo" on:click={() => redirectTo(idPageHome)} on:keydown={() => redirectTo(idPageHome)}>
        Le Guetteur yoga
    </div>
	<nav class="navigation">
        <div class="navigation__top">
            <div class="menu">
                <div class="menu__item" class:menu__item__selected={$storeCurRoute == idPageAPropos} on:click={() => redirectTo(idPageAPropos)} on:keydown={() => redirectTo(idPageAPropos)}>
                    {namePageAPropos}
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footer__social">
                <a href="https://www.instagram.com/fardeljack/" target="_blank"><div class="footer__instagram"></div></a>
                <a href="https://www.facebook.com/LeGuetteurYoga/" target="_blank"><div class="footer__facebook"></div></a>
            </div>
        </div>
    </nav>	
</div>